module.exports = __webpack_public_path__ + "img/10_90.61400a74.png";